import { Fragment } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

import Text from 'components/common/Text'

export default function Time({ label, time }) {
  return time ? (
    <Fragment>
      <Text as="h6" color="dark">
        <label>{label}</label>
      </Text>

      <Text as="small" color="medium">
        <time>{moment(time).format('h:mm:ss A')}</time>
      </Text>
    </Fragment>
  ) : null
}

// Time accepts Date strings and moment-ingested date objects
Time.propTypes = {
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  label: PropTypes.string
}
